import { useLocation } from 'react-router-dom';

import { IBrandingLocationState } from '../types/shell';
import { resolveBrandingRoute } from '../util/helpers';

export const useBrandingPathname = (): string => {
  const { pathname, state } = useLocation<IBrandingLocationState | undefined>();

  return resolveBrandingRoute(pathname, state);
};
